var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _path9, _path10, _ellipse, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotYellowFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 126,
    viewBox: "0 0 126 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_140_3601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5906 39.7786C19.9286 42.1689 19.6558 26.699 21.1554 16.3983C21.2135 15.9995 20.6658 15.8207 20.451 16.1616C-15.6359 73.4145 21.3418 122.665 67.9245 122.665C114.533 122.665 141.911 80.2739 107.74 17.1424C107.548 16.7884 106.977 16.9337 106.996 17.3357C107.513 28.2117 102.646 37.0058 92.3041 34.1775C77.8006 30.2113 92.8232 8.95145 69.8604 2.42368C69.567 2.34025 69.2892 2.62841 69.3977 2.91358C73.3096 13.1934 70.8774 22.6051 58.6625 24.0528C46.4926 25.4952 43.3815 16.5722 46.406 5.84262C46.495 5.52706 46.154 5.26145 45.8701 5.42535C30.5429 14.2721 46.2581 37.1985 32.5906 39.7786Z",
    fill: "#E79834"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5906 39.7786C19.9286 42.1689 19.6558 26.699 21.1554 16.3983C21.2135 15.9995 20.6658 15.8207 20.451 16.1616C-15.6359 73.4145 21.3418 122.665 67.9245 122.665C114.533 122.665 141.911 80.2739 107.74 17.1424C107.548 16.7884 106.977 16.9337 106.996 17.3357C107.513 28.2117 102.646 37.0058 92.3041 34.1775C77.8006 30.2113 92.8232 8.95145 69.8604 2.42368C69.567 2.34025 69.2892 2.62841 69.3977 2.91358C73.3096 13.1934 70.8774 22.6051 58.6625 24.0528C46.4926 25.4952 43.3815 16.5722 46.406 5.84262C46.495 5.52706 46.154 5.26145 45.8701 5.42535C30.5429 14.2721 46.2581 37.1985 32.5906 39.7786Z",
    stroke: "#1F2024",
    strokeWidth: 2.96471,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6431 31.2785C62.5361 55.1586 29.3145 62.4428 18.4698 42.8409C18.1171 42.2034 17.1059 42.3349 16.9861 43.0535C9.84369 85.92 40.9808 120.81 74.3031 118.961C109.438 117.012 131.424 64.6938 106.858 41.1982C106.562 40.9155 106.066 40.956 105.786 41.2542C83.0619 65.4432 79.7569 27.6548 56.2636 30.3089C55.8097 30.3602 55.5165 30.8397 55.6431 31.2785Z",
    fill: "#F2C95C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.243 50.7726C73.9286 68.6817 98.5456 70.5931 104.871 55.6487C105.154 54.9792 106.181 54.9628 106.395 55.6576C115.834 86.2758 96.5118 114.98 71.7338 117.167C45.5108 119.483 23.6774 83.4545 39.1989 63.4809C39.4486 63.1595 39.9392 63.1276 40.2593 63.3789C59.4607 78.4554 58.0465 50.6897 75.4886 49.9087C75.9458 49.8882 76.3016 50.3187 76.243 50.7726Z",
    fill: "#F9E174"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9332 83.9381C92.5706 83.9381 93.9382 85.2891 93.5076 86.8688C92.2216 91.587 87.906 95.0558 82.7803 95.0558C77.6546 95.0558 73.339 91.587 72.053 86.8688C71.6224 85.2891 72.99 83.9381 74.6274 83.9381H90.9332Z",
    fill: "#1F2024"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8338 63.1704C48.1017 63.0869 45.0149 66.0862 45.0149 69.8275C45.0149 73.408 47.8529 76.3487 51.4324 76.4728C71.4784 77.1677 84.5348 77.2937 104.165 76.5054C107.731 76.3622 110.54 73.4237 110.54 69.8615C110.54 66.1025 107.429 63.0972 103.683 63.1933C85.2102 63.6672 72.2529 63.627 51.8338 63.1704Z",
    fill: "#1F2024",
    stroke: "#1F2024",
    strokeWidth: 2.96471
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5397 63.1704C51.8075 63.0869 48.7208 66.0862 48.7208 69.8275C48.7208 73.408 51.5588 76.3487 55.1383 76.4728C75.1843 77.1677 88.2407 77.2937 107.871 76.5054C111.437 76.3622 114.245 73.4237 114.245 69.8615C114.245 66.1025 111.135 63.0972 107.389 63.1933C88.916 63.6672 75.9588 63.627 55.5397 63.1704Z",
    fill: "#EB0D18",
    stroke: "#1F2024",
    strokeWidth: 2.96471
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4471 63H75.6L71.5235 76.3412H63.3706L67.4471 63Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5397 63.1704C51.8075 63.0869 48.7208 66.0862 48.7208 69.8275C48.7208 73.408 51.5588 76.3487 55.1383 76.4728C75.1843 77.1677 88.2407 77.2937 107.871 76.5054C111.437 76.3622 114.245 73.4237 114.245 69.8615C114.245 66.1025 111.135 63.0972 107.389 63.1933C88.916 63.6672 75.9588 63.627 55.5397 63.1704Z",
    stroke: "#1F2024",
    strokeWidth: 2.96471
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_140_3601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2598 76.4286L10.319 64.4823L1.85297 64.4823C4.32019 77.1847 13.1806 91.2333 21.8329 95.9823L29.4524 95.5916C32.3634 95.6564 35.0556 94.6879 37.2598 92.4545C42.5325 87.1118 42.3208 78.8341 37.2598 76.4286Z",
    fill: "#E79834"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2598 76.4286L10.319 64.4823L1.85297 64.4823C4.32019 77.1847 13.1806 91.2333 21.8329 95.9823L29.4524 95.5916C32.3634 95.6564 35.0556 94.6879 37.2598 92.4545C42.5325 87.1118 42.3208 78.8341 37.2598 76.4286Z",
    stroke: "#1F2024",
    strokeWidth: 2.96471,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85297 64.4823C5.33877 87.3993 17.9541 103.407 28.7435 92.4545C34.0063 87.1118 33.7951 78.8341 28.7435 76.4286L1.85297 64.4823Z",
    fill: "#DE7E25",
    stroke: "#1F2024",
    strokeWidth: 2.96471,
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.4559,
    cy: 84.1234,
    rx: 5.00294,
    ry: 5.18824,
    fill: "#AF6017",
    stroke: "#1F2024",
    strokeWidth: 2.96471,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0015 79.7302C20.4833 80.6085 19.4618 82.25 19.4618 84.1301C19.4618 86.0102 20.4833 87.6517 22.0015 88.53C21.2544 88.9622 20.387 89.2095 19.4618 89.2095C16.6565 89.2095 14.3824 86.9354 14.3824 84.1301C14.3824 81.3248 16.6565 79.0507 19.4618 79.0507C20.387 79.0507 21.2544 79.298 22.0015 79.7302Z",
    fill: "#EDB146"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0015 79.7302L22.7438 81.0133C23.2018 80.7484 23.4839 80.2593 23.4839 79.7302C23.4839 79.201 23.2018 78.712 22.7438 78.4471L22.0015 79.7302ZM22.0015 88.53L22.7438 89.8131C23.2018 89.5482 23.4839 89.0591 23.4839 88.53C23.4839 88.0008 23.2018 87.5118 22.7438 87.2469L22.0015 88.53ZM20.9442 84.1301C20.9442 82.8005 21.6648 81.6375 22.7438 81.0133L21.2593 78.4471C19.3018 79.5794 17.9795 81.6994 17.9795 84.1301H20.9442ZM22.7438 87.2469C21.6648 86.6227 20.9442 85.4597 20.9442 84.1301H17.9795C17.9795 86.5607 19.3018 88.6808 21.2593 89.8131L22.7438 87.2469ZM21.2593 87.2469C20.7317 87.552 20.1195 87.7272 19.4618 87.7272V90.6919C20.6545 90.6919 21.7771 90.3723 22.7438 89.8131L21.2593 87.2469ZM19.4618 87.7272C17.4752 87.7272 15.8647 86.1167 15.8647 84.1301H12.9C12.9 87.7541 15.8378 90.6919 19.4618 90.6919V87.7272ZM15.8647 84.1301C15.8647 82.1435 17.4752 80.533 19.4618 80.533V77.5683C15.8378 77.5683 12.9 80.5061 12.9 84.1301H15.8647ZM19.4618 80.533C20.1195 80.533 20.7317 80.7081 21.2593 81.0133L22.7438 78.4471C21.7771 77.8879 20.6545 77.5683 19.4618 77.5683V80.533Z",
    fill: "#1F2024"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_140_3601",
    x: 4.44672,
    y: 0.927856,
    width: 120.072,
    height: 123.219,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.3,
    dy: -4.44706
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_140_3601"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_140_3601",
    x: 0.370605,
    y: 63,
    width: 42.2471,
    height: 34.4646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -7.41177
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_140_3601"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotYellowFrame);
export default __webpack_public_path__ + "static/media/hot_yellow_frame.c84e73c621950852aa2d2d36b8290ba0.svg";
export { ForwardRef as ReactComponent };